"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testimonial = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var star_1 = require("@/utils/star");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.testimonials), { lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1 })); };
var mapDispatchToProps = function () { return ({}); };
exports.testimonial = function (props) {
    if (!props.items)
        return null;
    var lang = props.lang;
    var viewAllHref = "/" + lang + "/about-us/testimonials";
    var renderTestimonial = function (it, i, showRating, lang) {
        var rate = it.rate;
        var rateClass = classnames_1.default([
            'c-homereview__stars',
            {
                'u-hidden': !showRating,
            },
        ]);
        return (React.createElement("div", { key: i, className: "c-testimonials__item" },
            React.createElement("div", { className: "c-testimonials__avator" },
                React.createElement("img", { "data-src": it.image, alt: it.name })),
            React.createElement("div", { className: "c-testimonials__name" }, it.name),
            React.createElement("div", { className: "c-testimonials__fulltext" }, it.fullText),
            React.createElement("div", { className: "c-testimonials__rating" },
                React.createElement("div", { className: rateClass }, star_1.renderStars(rate)),
                React.createElement("div", { className: "c-testimonials__value" },
                    it.rate,
                    " / 5.0")),
            React.createElement("div", { className: "c-testimonials__quotefrom" }, it.quoteFrom),
            React.createElement("div", { className: "c-testimonials__title" }, it.title)));
    };
    return (React.createElement("div", { className: "l-pad--6 l-pad-top--4" },
        React.createElement("div", { className: "c-testimonials" },
            React.createElement("div", { className: "c-testimonials__items" }, props.items.map(function (it, i) { return renderTestimonial(it, i, props.showRating, lang); })),
            React.createElement("div", { className: "c-testimonials__caption" },
                props.caption,
                React.createElement("br", null),
                React.createElement("a", { className: "o-textbtn", href: viewAllHref }, props.nameViewAll)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.testimonial);
